import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const KYCErrorStore = FloatingAlertStore.newFloatingAlertStore();
export const addSuccessAlert = ({
  title = 'growthPaymentsCore.errorAlert.genericErrorAlertTitle',
  message
} = {}) => {
  return FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: title
    }),
    message: message ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    }) : undefined,
    type: 'success'
  });
};
export const addDangerAlert = ({
  title,
  message,
  store = FloatingAlertStore,
  style
} = {}) => {
  let displayMessage = null;
  if (message) {
    displayMessage = message.includes('_jsx') ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: message,
      options: {
        href: window.location.href
      },
      elements: {
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    });
  }
  return store.addAlert({
    titleText: title ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: title
    }) : displayMessage ? undefined : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "growthPayments.errorAlert.genericErrorAlertTitle"
    }),
    message: displayMessage,
    type: 'danger',
    style: Object.assign({}, style)
  });
};
export const deleteKYCAlerts = () => {
  const currentAlerts = KYCErrorStore.getAlerts();
  Object.keys(currentAlerts).forEach(key => {
    KYCErrorStore.removeAlert(key);
  });
};